module.exports = __webpack_public_path__ + "static/media/task.49abaa50.svg";